<template>
  <v-app id="app" class="fill-height">
    <v-main class="fill-height">
      <router-view />
      <the-snackbar />
      <main-dialog
        v-if="isMainDialogLoaded"
        :is-visible.sync="isMainDialogVisible"
        :title="title"
        :body="body"
        :agree-text="buttonText"
        @agree="agreeCallback"
      >
      </main-dialog>
    </v-main>
  </v-app>
</template>

<script>
import { call, get } from 'vuex-pathify';
import sockets from '@/mixins/sockets';

import TheSnackbar from '@/components/TheSnackbar';
import { forEach, isBoolean, isNumber, isString } from 'lodash';

export default {
  name: 'App',
  mixins: [sockets],
  components: {
    TheSnackbar,
    MainDialog: () => import('@/components/MainDialog'),
  },
  data: () => ({
    isMainDialogLoaded: false,
    isMainDialogVisible: false,
    title: undefined,
    body: undefined,
    buttonText: undefined,
    agreeCallback: undefined,
  }),
  computed: {
    statusCheckers: get('asyncStatusChecker/statusCheckers'),
    gtagEventToSend: get('gtag/active'),
  },
  watch: {
    statusCheckers: {
      deepl: true,
      handler(nV, oV) {
        // stary arraj był dłuższy, czyli zmiana w arraju byłą usunięciem, więc nie odpalamy nasłuchu
        if (nV.length === 0 || nV?.length < oV?.length) {
          return;
        }
        this.pushChecker(this.getLast(nV));
      },
    },
    gtagEventToSend(/** @type {?EventDef} */ event) {
      if (event) this.sendGtagEvent(event);
      this.sendingGtagEvent(undefined);
    },
  },
  methods: {
    getLast(nV) {
      return nV[nV.length - 1];
    },
    async runChecker(checkingStatusFunction, successCallback, agreeCallback, interval, id) {
      let tiemoutId = undefined;
      const action = async () => {
        try {
          const isReady = await checkingStatusFunction();
          if (isReady) {
            this.agreeCallback = () => agreeCallback(this);
            //
            if (isReady !== 'cancel') {
              successCallback(this);
            }
            if (tiemoutId) {
              clearTimeout(tiemoutId);
            }
            return id;
          } else {
            tiemoutId = setTimeout(action, interval);
          }
        } catch (error) {
          console.log('  error', error);
        }
      };
      return await action();
    },
    pushChecker({ checkingStatusFunction, successCallback, agreeCallback, interval, id } = {}) {
      this.runChecker(checkingStatusFunction, successCallback, agreeCallback, interval, id);
    },
    sendingGtagEvent: call('gtag/sendingNextEvent'),
    sendGtagEvent(/** @type {EventDef} */ event) {
      if (!this.$gtag) return;
      const toString = params => (params ? JSON.stringify(params) : undefined);
      const copyParam = param => (isString(param) || isNumber(param) || isBoolean(param) ? param : undefined);
      function copyParams(source, prefix = '') {
        let target = {};
        forEach(source || {}, (value, key) => (target[`${prefix}${key.trim()}`] = copyParam(value)));
        return target;
      }
      this.$gtag.event(event.action, {
        ...copyParams(event.extra_params),
        // nadpisanie wrazie pokrywających się
        event_category: event.category,
        event_label: event.label ? event.label : toString(event.params),
        value: event.value,
        ...copyParams(event.params, 'param_'),
      });
    },
  },
  mounted() {
    this.initSocket();
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  overflow-y: hidden;
}
.row + .row {
  margin-top: 0 !important;
}
#app {
  font-family: Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  .menu-max-width-content div {
    width: 100%;
  }
  * {
    scrollbar-color: #8f8f8f white;
    scrollbar-width: thin;
  }
}
.treeview-type-select ::placeholder {
  color: white !important;
}
.hover-list-element:hover {
  background-color: rgba(188, 188, 188, 0.2) !important;
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #8f8f8f;
  border: 0px none #ffffff;
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #787878;
}
::-webkit-scrollbar-thumb:active {
  background: #6e6e6e;
}
::-webkit-scrollbar-track {
  background: #ededed;
  border: 0px none #ffffff;
  border-radius: 3px;
}
::-webkit-scrollbar-track:hover {
  background: #ededed;
}
::-webkit-scrollbar-track:active {
  background: #ededed;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
